<div class="container">
    <div class="title">{{"help.title" | translate}}</div>
    <div class="theme_container">
        <app-one-help-theme titleBloc="claim" [tag]=data.tag></app-one-help-theme>
        <app-one-help-theme titleBloc="tracking" [tag]=data.tag></app-one-help-theme>
        <app-one-help-theme titleBloc="delivery-choice" [tag]=data.tag></app-one-help-theme>
        <app-one-help-theme titleBloc="availability" [tag]=data.tag></app-one-help-theme>
        <app-one-help-theme titleBloc="unavailability" [tag]=data.tag></app-one-help-theme>
    </div>
</div>
<div class="button-bar">
    <div class="button" (click)="onNoClick()">retour</div>
</div>